import * as React from 'react'
import { Facebook, Instagram, Translate, Twitter } from '@mui/icons-material'
import { Box, Link, Typography, Container } from '@mui/material'
import Grid from '@mui/material/Grid2'
import azwellLogo from '../asset/company_logo.png'
import Divider from '@mui/material/Divider'

export default function Footer() {
  return (
    <Grid container>
      <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#2C2D33' }}>
        <Box
          display="flex"
          alignItems="center"
          component="footer"
          sx={{
            marginTop: 'auto',
            position: 'relative',
            height: '70px',
            padding: '100px, 120px, 100px, 120px',
            gap: '10px',
            transform: '-100%',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Noto Sans KR',
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '17.38px',
              textAlign: 'left',
              textUnderlinePosition: 'from-font',
              textDecorationSkipInk: 'none',
              color: '#CCCCCC',
            }}
          >
            Copyrightⓒ2024.Azwell All Rights Reserved.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  )
}
